/**
 * Edit feature block.
 * @module components/manage/Blocks/Feature/Edit
 * @nk24:CMScom created 2021/03/18
 */

const Schema = {
  title: 'Item',

  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [],
    },
    {
      id: 'text_color',
      title: 'Text Color',
      fields: ['invert_text_color'],
    },
    {
      id: 'images',
      title: 'Images',
      fields: ['image'],
    },
    {
      id: 'background-images',
      title: 'Background Images',
      fields: ['background_image_PC', 'background_image_SP'],
    },
    {
      id: 'link_path',
      title: 'Link Path',
      fields: ['link_path'],
    },
    {
      id: 'targets',
      title: 'Targets',
      fields: ['targets'],
    },
  ],
  properties: {
    invert_text_color: {
      title: 'Invert Text Color',
      type: 'boolean',
    },
    image: {
      title: 'Image',
      widget: 'object_browser',
      mode: 'image',
      selectedItemAttrs: [], // path and Title
    },
    background_image_PC: {
      title: 'Background image for PC',
      widget: 'object_browser',
      mode: 'image',
      selectedItemAttrs: [],
    },
    background_image_SP: {
      title: 'Background image for SP',
      widget: 'object_browser',
      mode: 'image',
      selectedItemAttrs: [],
    },
    link_path: {
      title: 'Link Path',
      widget: 'object_browser',
      mode: 'link',
      allowExternals: true,
      selectedItemAttrs: [],
    },
    targets: {
      title: 'Targets',
      widget: 'target_with_unselected',
      isMulti: true,
    },
  },
  required: [],
};

export default Schema;
